import http from '@/utils/http'

export default {
  getQRCode () {
    return http.get('/promotion/api/v1/official/website/application')
  },
  getApplication (parmas) {
    return http.post('/promotion/api/v1/official/website/login/qrcode', parmas)
  }
}



// WEBPACK FOOTER //
// ./src/components/login/api/index.js